// extracted by mini-css-extract-plugin
export default {"logo":"MainNavigation_logo__Slzhs","dev":"MainNavigation_dev__iGT4i","menuItem":"MainNavigation_menuItem__P1+yz"};